import { createContext, useContext } from 'react';

const EntityContext = createContext(null);

/**
 * The page's entity, for the blocks it composes. Read it rather than threading
 * it through props: a related table needs the country, the week and the export
 * name, and none of that is the table's caller's business.
 */
export const useEntityPageContext = () => {
    const page = useContext(EntityContext);
    if (!page)
        throw new Error(
            'useEntityPageContext: render this inside an <EntityPage>',
        );
    return page;
};

export default EntityContext;
